import React, { useState } from 'react';
import styled from 'styled-components';

import { ReactComponent as ShoppingCart } from 'assets/icons/shopping_cart.svg';
import { ReactComponent as TicketIcon } from 'assets/icons/filter_ticket_icon.svg';
import { ReactComponent as MusicIcon } from 'assets/icons/filter_play_circle_filled_white.svg';
import { ReactComponent as FeaturedIcon } from 'assets/icons/product_icon.svg';

import { variables } from 'components/theme';
import { openCart } from 'context/cart/actions';
import { useStateValue } from 'context/store';
import { useWindowSize } from 'utils/hooks';
import Item from './item';

const DockWrapper = styled.div`
  width: 100%;
  height: 56px;
  background: ${variables.colors.white};
  box-shadow: 0 3px 10px #0000001a;
  border-radius: 6px 6px 0 0;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 5;
`;

const DockMenu = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-around;
`;

const DockMenuItem = styled.button`
  border: none;
  background: transparent;
  color: #707070;
  padding: 0 28px;

  svg {
    fill: #707070;
  }
`;

function Dock({ content }) {
  const {
    state: { tabs },
    dispatch
  } = useStateValue();
  const { width } = useWindowSize();
  const [currentTab, setActiveTab] = useState(tabs.tabIndex);

  const items = [
    {
      id: 0,
      title: 'Featured',
      Icon: FeaturedIcon
    },
    {
      id: 1,
      title: 'Events',
      Icon: TicketIcon
    }
    // {
    //   id: 2,
    //   title: 'Music',
    //   Icon: MusicIcon
    // }
  ];

  function handleContent() {
    if (content) {
      return content;
    }
    return (
      <DockMenu>
        {items.map(item => (
          <Item
            key={item.id}
            {...item}
            currentTab={currentTab}
            setActiveTab={setActiveTab}
          />
        ))}
        <DockMenuItem onClick={() => dispatch(openCart())}>
          <ShoppingCart />
          <h6>Cart</h6>
        </DockMenuItem>
      </DockMenu>
    );
  }

  return width <= 992 && <DockWrapper>{handleContent()}</DockWrapper>;
}

export default Dock;
